export default {
  getCustomers(state) {
     return state.customers
  },
  getCustomer(state) {
     return state.customer
  },
}